import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { SearchPlaceComponent } from '../search-place/search-place.component';
import { PlaceResponse } from '../../../models/orders/place.model';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-search-place-dialog',
  standalone: true,
  imports: [
    SearchPlaceComponent,
    MatDialogModule,
    MatButtonModule,
  ],
  templateUrl: './search-place-dialog.component.html',
  styleUrl: './search-place-dialog.component.scss'
})
export class SearchPlaceDialogComponent {

  @Output() placeSelected = new EventEmitter<PlaceResponse>();
  @ViewChild(SearchPlaceComponent) searchPlaceComponent!: SearchPlaceComponent; // Access the SearchPlaceComponent

  constructor(
    public dialogRef: MatDialogRef<SearchPlaceDialogComponent>
  ) { }

  onPlaceSelected(place: PlaceResponse) {
    this.placeSelected.emit(place);
    this.dialogRef.close(place); // Close the dialog and pass the selected place
  }

  onCancelClick(): void {
    this.dialogRef.close(); // Close the dialog without passing any data
  }
}